import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getImageByWidth } from '../../utils/api';
import { fetchVimeoOembedData } from '../../utils/vimeo';
import AnimateHeight from 'react-animate-height';


class ListGroup extends Component {
  constructor (props) {
    super(props);
    this.state = {
      vimeoImage: null,
    };
  }

  componentDidMount () {
    const { posterItem } = this.props;
    if (!posterItem) {
      this.fetchData();
      return null;
    }

    if (
      (!posterItem.previewImages || !posterItem.previewImages.horizontalThumbnail || !posterItem.previewImages.horizontalThumbnail.length) &&
      posterItem.metadata &&
      (posterItem.metadata.sourceUrl || posterItem.metadata.sourceId)
    ) {
      this.fetchData();
    }
  }

  fetchData () {
    const { posterItem: { metadata } } = this.props;
    const url = metadata.sourceUrl || `https://vimeo.com/${metadata.sourceId}`;
    fetchVimeoOembedData(url, 1280).then(data => {
      this.setState({ vimeoImage: data.thumbnailUrl });
    });
  }

  render () {
    const {
      uid,
      name,
      description,
      durationFriendly,
      expanded,
      active,
      posterItem,
      children,
      onGroupClick,
      onThumbClick,
    } = this.props;
    const classes = classNames({
      'playlist-itemlist-item': true,
      group: true,
      background: active && !expanded,
      expanded,
    });
    const tdStyle = {
      transitionDuration: `${80 * children.length}ms`,
    };

    let thumbnailUrl = '';
    try {
      thumbnailUrl = getImageByWidth(posterItem.previewImages.horizontalThumbnail, 300).url;
    } catch (e) {
      thumbnailUrl = this.state.vimeoImage;
    }

    return (
      <Fragment>
        <div key={uid} className={classes} style={tdStyle} onClick={() => onGroupClick(uid)}>
          <div className="thumbnail-container">
            <div
              className="thumbnail"
              style={{ backgroundImage: `url('${thumbnailUrl}')` }}
              onClick={e => {
                e.stopPropagation();
                onThumbClick(uid);
              }}
            />
          </div>
          <div className="details">
            <h4 className="heading-display-light" style={tdStyle}>{name}</h4>
            <div className="meta">
              <span className="float-right expand theme-red">{expanded ? 'Collapse ▲' : 'Expand ▼'}</span>
              {children.length} videos{durationFriendly ? ` (${durationFriendly})` : ''}
            </div>
          </div>
          {description ? <div className="caption mt-2" style={{ flex: '1 1 100%' }} dangerouslySetInnerHTML={{ __html: description }} /> : null}
        </div>
        <AnimateHeight key={`${uid}-children`} duration={80 * children.length} height={expanded ? 'auto' : 0} onAnimationEnd={() => {}}>
          <div className="playlist-itemlist-children">
            {children}
          </div>
        </AnimateHeight>
      </Fragment>
    );
  }
}

ListGroup.propTypes = {
  uid: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  durationFriendly: PropTypes.string,
  expanded: PropTypes.bool,
  onGroupClick: PropTypes.func,
  onThumbClick: PropTypes.func,
};

ListGroup.defaultProps = {
  children: [],
  expanded: false,
  onGroupClick: () => {},
  onThumbClick: () => {},
};

export default ListGroup;



// WEBPACK FOOTER //
// ./src/components/Playlist/ListGroup.js